import { Button } from '../button';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

interface PrimaryButtonProps extends ComponentPropsWithoutRef<typeof Button> {
    children: ReactNode;
    className?: string;
}

export function PrimaryButton({ children, className, ...props }: PrimaryButtonProps) {
    return (
        <Button
            className={`
              bg-primery-blue-700 h-auto text-white-blue-50 text-xs font-normal p-2 rounded-sm  
              hover:bg-primery-blue-500 
              focus:outline-none focus:ring-2 focus:ring-primery-blue-700 focus:ring-offset-2
              disabled:bg-primery-blue-200 disabled:opacity-50
              md:rounded-md md:text-sm md:font-medium md:px-3 md:py-2
              lg:px-4 lg:text-base lg:leading-5
              xl:py-3
        ${className || ''}
      `}
            {...props}
        >
            {children}
        </Button>
    );
}
